import { render, staticRenderFns } from "./Wordpress.vue?vue&type=template&id=4e8d9a6f&"
import script from "./Wordpress.vue?vue&type=script&lang=js&"
export * from "./Wordpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports